import {
  IWorkgroup,
  IWorkgroupData,
  IWorkgroupFieldError,
  IWorkgroupFieldErrorData
} from './workgroup.types';

export class Workgroup implements IWorkgroup {
  readonly id?: number;
  readonly name: string = '';
  readonly description?: string = '';

  constructor(data?: IWorkgroupData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }
      if (data.description) {
        this.description = data.description;
      }
      if (data.name) {
        this.name = data.name;
      }
    }
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }

  get workgroupInfo(): string {
    return `${this.name} ${this.description}`.trim();
  }

  toString(): string {
    return `${this.name}`.trim();
  }
}

export class WorkgroupFieldError implements IWorkgroupFieldError {
  readonly name: string[] = [];
  readonly description: string[] = [];

  constructor(data?: IWorkgroupFieldErrorData) {
    if (data) {
      if (data.name) {
        this.name = data.name;
      }

      if (data.description) {
        this.description = data.description;
      }
    }
  }

  clearErrors(): void {
    this.name.splice(0, this.name.length);
    this.description.splice(0, this.description.length);
  }

  static isWorkgroupFieldError(data: IWorkgroupFieldErrorData): boolean {
    if (data.name && Array.isArray(data.name)) {
      return true;
    } else if (data.description && Array.isArray(data.description)) {
      return true;
    }
    return false;
  }
}
